import request from '@/config/axios'

// 钟点房模板 VO
export interface HourlyTemplateVO {
  id?: string | number
  shopId: string | number
  spuId?: string | number
  templateCode: string
  templateName: string
  timeSlotStart: string // HH:mm 格式
  timeSlotEnd: string // HH:mm 格式
  baseHours: number
  basePrice: number
  overtimeRate: number
  applicableRoomTypes?: string
  status: number // 0启用 1禁用
  createTime?: Date
}

// 获取钟点房模板分页
export const getHourlyTemplatePage = (params: any) => {
  return request.get({ url: '/hotel/hourly-template/page', params })
}

// 获取钟点房模板详情
export const getHourlyTemplate = (id: string | number) => {
  return request.get({ url: '/hotel/hourly-template/get?id=' + id })
}

// 创建钟点房模板
export const createHourlyTemplate = (data: HourlyTemplateVO) => {
  return request.post({ url: '/hotel/hourly-template/create', data })
}

// 更新钟点房模板
export const updateHourlyTemplate = (data: HourlyTemplateVO) => {
  return request.put({ url: '/hotel/hourly-template/update', data })
}

// 删除钟点房模板
export const deleteHourlyTemplate = (id: string | number) => {
  return request.delete({ url: '/hotel/hourly-template/delete?id=' + id })
}

// 批量删除钟点房模板
export const deleteHourlyTemplateList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/hourly-template/delete-list?ids=' + ids.join(',') })
}
